import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const Datenschutz: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      backgroundColor: '#f5f5f5',
      py: 4
    }}>
      <Container maxWidth="md">
        <Button 
          startIcon={<ArrowBackIcon />} 
          onClick={() => navigate('/')}
          sx={{ mb: 3 }}
        >
          Zurück zur Startseite
        </Button>
        
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            borderRadius: 2,
            backgroundColor: 'white'
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
            Datenschutzerklärung
          </Typography>
          <Typography variant="subtitle1" sx={{ mb: 3, fontStyle: 'italic' }}>
            Stand: 16.04.2025
          </Typography>
          
          <Box sx={{ 
            p: 3, 
            border: '1px solid #e0e0e0', 
            borderRadius: 1,
            backgroundColor: '#f9f9f9',
            mb: 3
          }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
              Inhalt folgt
            </Typography>
            <Typography variant="body1" paragraph>
              Dies ist ein Platzhalter für die Datenschutzerklärung. Der tatsächliche Inhalt wird zu einem späteren Zeitpunkt eingefügt.
            </Typography>
            <Typography variant="body1">
              Bitte kontaktieren Sie uns für weitere Informationen zu unserer Datenschutzerklärung.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Datenschutz; 